// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-css-___base__main___gyamL {
  background: white;
  color: #444;
  margin: 5px 0;
}

/* .alert and .btn styles copied from Bootstrap */
.src-css-___base__alert___i367L {
  padding: 1em;
  margin-bottom: 1.5em;
  border: 1px solid transparent;
  border-radius: 4px;
}

.src-css-___base__alert-danger___JTFmF {
  color: var(--danger-text);
  background-color: var(--danger-bg);
  border-color: var(--danger-border);
}

.src-css-___base__alert-info___dB3_s {
  color: var(--info-text);
  background-color: var(--info-bg);
  border-color: var(--info-border);
}

.src-css-___base__alert-warning___WbMdQ {
  color: var(--warning-text);
  background-color: var(--warning-bg);
  border-color: var(--warning-border);
}

.src-css-___base__btn___reJDQ {
  border: 1px solid transparent;
  border-radius: 4px;
  display: inline-block;
  padding: 0.5em 1em;
  margin-bottom: 0;
  line-height: inherit;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  touch-action: manipulation;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.src-css-___base__btn___reJDQ:focus,
.src-css-___base__btn___reJDQ:active:focus {
  outline: 5px auto -webkit-focus-ring-color;
  outline-offset: -2px;
}

.src-css-___base__btn___reJDQ:hover,
.src-css-___base__btn___reJDQ:focus {
  color: var(--gray-darker);
  text-decoration: none;
}

.src-css-___base__btn___reJDQ:active {
  outline: 0;
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, .125);
}

.src-css-___base__btn___reJDQ[disabled]  {
  box-shadow: none;
  opacity: .65;
}

.src-css-___base__btn-default___hGnUz {
  color: var(--gray-darker);
  background-color: #fff;
  border-color: var(--default-border);
}

.src-css-___base__btn-default___hGnUz:focus {
  color: var(--gray-darker);
  background-color: #e6e6e6;
  border-color: #8c8c8c;
}

.src-css-___base__btn-default___hGnUz:hover {
  color: var(--gray-darker);
  background-color: #e6e6e6;
  border-color: #adadad;
}

.src-css-___base__btn-default___hGnUz:active {
  color: var(--gray-darker);
  background-color: #e6e6e6;
  border-color: #adadad;
}

.src-css-___base__btn-default___hGnUz:active:hover,
.src-css-___base__btn-default___hGnUz:active:focus {
  color: var(--gray-darker);
  background-color: #d4d4d4;
  border-color: #8c8c8c;
}

.src-css-___base__btn-default___hGnUz[disabled]:hover,
.src-css-___base__btn-default___hGnUz[disabled]:focus {
  background-color: #fff;
  border-color: var(--default-border);
}

.src-css-___base__btn-link___a4XVF {
  font-weight: normal;
  color: var(--brand-primary);
  border-radius: 0;
}

.src-css-___base__btn-link___a4XVF,
.src-css-___base__btn-link___a4XVF:active,
.src-css-___base__btn-link___a4XVF[disabled] {
  background-color: transparent;
  box-shadow: none;
}

.src-css-___base__btn-link___a4XVF,
.src-css-___base__btn-link___a4XVF:hover,
.src-css-___base__btn-link___a4XVF:focus,
.src-css-___base__btn-link___a4XVF:active {
  border-color: transparent;
}

.src-css-___base__btn-link___a4XVF:hover,
.src-css-___base__btn-link___a4XVF:focus {
  color: #23527c;
  text-decoration: underline;
  background-color: transparent;
}

.src-css-___base__btn-link___a4XVF[disabled]:hover,
.src-css-___base__btn-link___a4XVF[disabled]:focus {
  color: var(--gray-light);
  text-decoration: none;
}

.src-css-___base__btn-primary___Ixd9h {
  color: #fff;
  background-color: var(--brand-primary);
  border-color: #2e6da4;
}

.src-css-___base__btn-primary___Ixd9h:focus {
  color: #fff;
  background-color: #286090;
  border-color: #122b40;
}

.src-css-___base__btn-primary___Ixd9h:hover {
  color: #fff;
  background-color: #286090;
  border-color: #204d74;
}

.src-css-___base__btn-primary___Ixd9h:active {
  color: #fff;
  background-color: #286090;
  border-color: #204d74;
}

.src-css-___base__btn-primary___Ixd9h:active:hover,
.src-css-___base__btn-primary___Ixd9h:active:focus {
  color: #fff;
  background-color: #204d74;
  border-color: #122b40;
}

.src-css-___base__btn-primary___Ixd9h[disabled]:hover,
.src-css-___base__btn-primary___Ixd9h[disabled]:focus {
  background-color: var(--brand-primary);
  border-color: #2e6da4;
}
/* end from Bootstrap  */
`, "",{"version":3,"sources":["webpack://./src/css/base.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,WAAW;EACX,aAAa;AACf;;AAEA,iDAAiD;AACjD;EACE,YAAY;EACZ,oBAAoB;EACpB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kCAAkC;EAClC,kCAAkC;AACpC;;AAEA;EACE,uBAAuB;EACvB,gCAAgC;EAChC,gCAAgC;AAClC;;AAEA;EACE,0BAA0B;EAC1B,mCAAmC;EACnC,mCAAmC;AACrC;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,0BAA0B;EAC1B,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;;EAEE,0CAA0C;EAC1C,oBAAoB;AACtB;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,+CAA+C;AACjD;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,mCAAmC;AACrC;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,sBAAsB;EACtB,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;;;EAGE,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;;;;EAIE,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;EACd,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;;EAEE,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,sCAAsC;EACtC,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,sCAAsC;EACtC,qBAAqB;AACvB;AACA,wBAAwB","sourcesContent":[".main {\n  background: white;\n  color: #444;\n  margin: 5px 0;\n}\n\n/* .alert and .btn styles copied from Bootstrap */\n.alert {\n  padding: 1em;\n  margin-bottom: 1.5em;\n  border: 1px solid transparent;\n  border-radius: 4px;\n}\n\n.alert-danger {\n  color: var(--danger-text);\n  background-color: var(--danger-bg);\n  border-color: var(--danger-border);\n}\n\n.alert-info {\n  color: var(--info-text);\n  background-color: var(--info-bg);\n  border-color: var(--info-border);\n}\n\n.alert-warning {\n  color: var(--warning-text);\n  background-color: var(--warning-bg);\n  border-color: var(--warning-border);\n}\n\n.btn {\n  border: 1px solid transparent;\n  border-radius: 4px;\n  display: inline-block;\n  padding: 0.5em 1em;\n  margin-bottom: 0;\n  line-height: inherit;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: middle;\n  touch-action: manipulation;\n  cursor: pointer;\n  user-select: none;\n}\n\n.btn:focus,\n.btn:active:focus {\n  outline: 5px auto -webkit-focus-ring-color;\n  outline-offset: -2px;\n}\n\n.btn:hover,\n.btn:focus {\n  color: var(--gray-darker);\n  text-decoration: none;\n}\n\n.btn:active {\n  outline: 0;\n  box-shadow: inset 0 3px 5px rgba(0, 0, 0, .125);\n}\n\n.btn[disabled]  {\n  box-shadow: none;\n  opacity: .65;\n}\n\n.btn-default {\n  color: var(--gray-darker);\n  background-color: #fff;\n  border-color: var(--default-border);\n}\n\n.btn-default:focus {\n  color: var(--gray-darker);\n  background-color: #e6e6e6;\n  border-color: #8c8c8c;\n}\n\n.btn-default:hover {\n  color: var(--gray-darker);\n  background-color: #e6e6e6;\n  border-color: #adadad;\n}\n\n.btn-default:active {\n  color: var(--gray-darker);\n  background-color: #e6e6e6;\n  border-color: #adadad;\n}\n\n.btn-default:active:hover,\n.btn-default:active:focus {\n  color: var(--gray-darker);\n  background-color: #d4d4d4;\n  border-color: #8c8c8c;\n}\n\n.btn-default[disabled]:hover,\n.btn-default[disabled]:focus {\n  background-color: #fff;\n  border-color: var(--default-border);\n}\n\n.btn-link {\n  font-weight: normal;\n  color: var(--brand-primary);\n  border-radius: 0;\n}\n\n.btn-link,\n.btn-link:active,\n.btn-link[disabled] {\n  background-color: transparent;\n  box-shadow: none;\n}\n\n.btn-link,\n.btn-link:hover,\n.btn-link:focus,\n.btn-link:active {\n  border-color: transparent;\n}\n\n.btn-link:hover,\n.btn-link:focus {\n  color: #23527c;\n  text-decoration: underline;\n  background-color: transparent;\n}\n\n.btn-link[disabled]:hover,\n.btn-link[disabled]:focus {\n  color: var(--gray-light);\n  text-decoration: none;\n}\n\n.btn-primary {\n  color: #fff;\n  background-color: var(--brand-primary);\n  border-color: #2e6da4;\n}\n\n.btn-primary:focus {\n  color: #fff;\n  background-color: #286090;\n  border-color: #122b40;\n}\n\n.btn-primary:hover {\n  color: #fff;\n  background-color: #286090;\n  border-color: #204d74;\n}\n\n.btn-primary:active {\n  color: #fff;\n  background-color: #286090;\n  border-color: #204d74;\n}\n\n.btn-primary:active:hover,\n.btn-primary:active:focus {\n  color: #fff;\n  background-color: #204d74;\n  border-color: #122b40;\n}\n\n.btn-primary[disabled]:hover,\n.btn-primary[disabled]:focus {\n  background-color: var(--brand-primary);\n  border-color: #2e6da4;\n}\n/* end from Bootstrap  */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `src-css-___base__main___gyamL`,
	"alert": `src-css-___base__alert___i367L`,
	"alert-danger": `src-css-___base__alert-danger___JTFmF`,
	"alertDanger": `src-css-___base__alert-danger___JTFmF`,
	"alert-info": `src-css-___base__alert-info___dB3_s`,
	"alertInfo": `src-css-___base__alert-info___dB3_s`,
	"alert-warning": `src-css-___base__alert-warning___WbMdQ`,
	"alertWarning": `src-css-___base__alert-warning___WbMdQ`,
	"btn": `src-css-___base__btn___reJDQ`,
	"btn-default": `src-css-___base__btn-default___hGnUz`,
	"btnDefault": `src-css-___base__btn-default___hGnUz`,
	"btn-link": `src-css-___base__btn-link___a4XVF`,
	"btnLink": `src-css-___base__btn-link___a4XVF`,
	"btn-primary": `src-css-___base__btn-primary___Ixd9h`,
	"btnPrimary": `src-css-___base__btn-primary___Ixd9h`
};
export default ___CSS_LOADER_EXPORT___;
